import DesignUnderLine from "../../components/ExcerciseTypes/Design/DesignUnderLine";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P18-E1",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [{ url: "img/FriendsPlus/Page18/E1/1.jpg" }],
      [{ url: "img/FriendsPlus/Page18/E1/2.jpg" }],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 2",
    id: "SB1-U2-P18-E2",
    audio: "img/FriendsPlus/Page18/Audio/audio-e2-p18.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      // Row
      [
        // Column1
        { url: "img/FriendsPlus/Page18/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page18/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page18/Audio/tieude-e2-p18.mp3",
        },
        { url: "img/FriendsPlus/Page18/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page18/E2/4.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page18/E2/5.jpg" },
        {
          url: "img/FriendsPlus/Page18/E2/6.jpg",
          audioUrl: "img/FriendsPlus/Page18/Audio/hinh1-e2-p18.mp3",
        },
        { url: "img/FriendsPlus/Page18/E2/7.jpg" },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page18/E2/8.jpg" },
        {
          url: "img/FriendsPlus/Page18/E2/9.jpg",
          audioUrl: "img/FriendsPlus/Page18/Audio/hinh1-e2-p18.mp3",
        },
        { url: "img/FriendsPlus/Page18/E2/10.jpg" },
        {
          url: "img/FriendsPlus/Page18/E2/11.jpg",
          audioUrl: "img/FriendsPlus/Page18/Audio/hinh2-e2-p18.mp3",
        },
        { url: "img/FriendsPlus/Page18/E2/12.jpg" },
        {
          url: "img/FriendsPlus/Page18/E2/13.jpg",
          audioUrl: "img/FriendsPlus/Page18/Audio/hinh3-e2-p18.mp3",
        },
        { url: "img/FriendsPlus/Page18/E2/14.jpg" },
      ],
      [
        // Column5
        { url: "img/FriendsPlus/Page18/E2/15.jpg" },
        {
          url: "img/FriendsPlus/Page18/E2/16.jpg",
          audioUrl: "img/FriendsPlus/Page18/Audio/hinh2-e2-p18.mp3",
        },
        { url: "img/FriendsPlus/Page18/E2/17.jpg" },
        {
          url: "img/FriendsPlus/Page18/E2/18.jpg",
          audioUrl: "img/FriendsPlus/Page18/Audio/hinh3-e2-p18.mp3",
        },
        { url: "img/FriendsPlus/Page18/E2/19.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page18/E2/20.jpg" }],
      [
        // Column7
        { url: "img/FriendsPlus/Page18/E2/21.jpg" },
        {
          url: "img/FriendsPlus/Page18/E2/22.jpg",
          audioUrl: "img/FriendsPlus/Page18/Audio/hinh4-e2-p18.mp3",
        },
        { url: "img/FriendsPlus/Page18/E2/23.jpg" },
        {
          url: "img/FriendsPlus/Page18/E2/24.jpg",
          audioUrl: "img/FriendsPlus/Page18/Audio/hinh5-e2-p18.mp3",
        },
        { url: "img/FriendsPlus/Page18/E2/25.jpg" },
        {
          url: "img/FriendsPlus/Page18/E2/26.jpg",
          audioUrl: "img/FriendsPlus/Page18/Audio/hinh6-e2-p18.mp3",
        },
        { url: "img/FriendsPlus/Page18/E2/27.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page18/E2/28.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P18-E3",
    audio: "",
    video: "",
    component: DesignUnderLine,
    // hideBtnFooter: true,
    totalInput: 5,
    exerciseKey: "img/FriendsPlus/Page18/E3/Key/answerKey.png",
    titleImage: "",
    questionImage: [
      [{ url: "img/FriendsPlus/Page18/E3/1.jpg" }],
      [{ url: "img/FriendsPlus/Page18/E3/2.jpg" }],
      [{ url: "img/FriendsPlus/Page18/E3/3.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page18/E3/4.jpg" },
        { url: "img/FriendsPlus/Page18/E3/5.jpg", input: 1, isCorrect: true },
        { url: "img/FriendsPlus/Page18/E3/6.jpg" },
        { url: "img/FriendsPlus/Page18/E3/7.jpg", input: 1, isCorrect: true },
        { url: "img/FriendsPlus/Page18/E3/8.jpg" },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page18/E3/9.jpg" },
        { url: "img/FriendsPlus/Page18/E3/10.jpg", input: 2, isCorrect: true },
        { url: "img/FriendsPlus/Page18/E3/11.jpg" },
        { url: "img/FriendsPlus/Page18/E3/12.jpg", input: 2, isCorrect: true },
        { url: "img/FriendsPlus/Page18/E3/13.jpg" },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page18/E3/14.jpg" },
        { url: "img/FriendsPlus/Page18/E3/15.jpg", input: 3, isCorrect: true },
        { url: "img/FriendsPlus/Page18/E3/16.jpg" },
        { url: "img/FriendsPlus/Page18/E3/17.jpg", input: 3, isCorrect: true },
        { url: "img/FriendsPlus/Page18/E3/18.jpg" },
      ],
      [
        // Column5
        { url: "img/FriendsPlus/Page18/E3/19.jpg" },
        { url: "img/FriendsPlus/Page18/E3/20.jpg", input: 4, isCorrect: true },
        { url: "img/FriendsPlus/Page18/E3/21.jpg" },
        { url: "img/FriendsPlus/Page18/E3/22.jpg", input: 4, isCorrect: true },
        { url: "img/FriendsPlus/Page18/E3/23.jpg" },
      ],
      [
        // Column6
        { url: "img/FriendsPlus/Page18/E3/24.jpg" },
        { url: "img/FriendsPlus/Page18/E3/25.jpg", input: 5, isCorrect: true },
        { url: "img/FriendsPlus/Page18/E3/26.jpg" },
        { url: "img/FriendsPlus/Page18/E3/27.jpg", input: 5, isCorrect: true },
        { url: "img/FriendsPlus/Page18/E3/28.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page18/E3/29.jpg" }],
    ],
  },
};

export default json;
